/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestMetricTargetDto } from '../../models/harvest-metric-target-dto';
import { HarvestSex } from '../../models/harvest-sex';

export interface GetTargetValues$Params {
  brand: string;
  onhousehatching?: boolean;
  sex: HarvestSex;
}

export function getTargetValues(http: HttpClient, rootUrl: string, params: GetTargetValues$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestMetricTargetDto>> {
  const rb = new RequestBuilder(rootUrl, getTargetValues.PATH, 'get');
  if (params) {
    rb.query('brand', params.brand, {});
    rb.query('onhousehatching', params.onhousehatching, {});
    rb.query('sex', params.sex, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestMetricTargetDto>;
    })
  );
}

getTargetValues.PATH = '/api/metric-target/get';
